import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {globalEnv} from '../../connection/global/global.env';
import {RequestService} from '../../../handlers/request/request.service';
import {batch} from '../../api/batch/batch.api';
import {LogEvent} from '../../models/batch/request/batch-req';
import {BatchResponse} from '../../models/batch/response/batch-res';

@Injectable({
  providedIn: 'root',
})
export class BatchService {
  constructor(private req: RequestService) {}

  logEvent(data: LogEvent): Observable<BatchResponse> {
    return this.req.post(`${globalEnv.gatewayData}${batch.logEvent}`, data, null, null, null, null, null, null);
  }
}
